import { useContext } from 'react';
import styled from 'styled-components';
import type { ProductListBrandHeaderModel } from 'autogen/swagger/all';
import PictureWithLink from 'components/generic/picture/PictureWithLink';
import { Typography } from 'components/generic/typography';
import Layout from 'components/Layout';
import ContentfulContext from 'components/pages/Contentful/ContentfulContext';
import { breakpoint, sizes } from 'variables';

const ImageContainer = styled.div`
    display: none;

    ${breakpoint.up(sizes.sm)} {
        display: flex;
        max-width: 200px;
        max-height: 200px;
        margin-left: auto;
        margin-right: auto;
    }
`;

const StyledHeadline = styled(Typography.Headline)<Pick<ProductListBrandHeaderModel, 'logo'>>`
    display: block;

    ${breakpoint.up(sizes.sm)} {
        display: ${({ logo }) => (logo ? 'none' : 'block')};
    }

    & > img {
        max-height: 100%;
    }
`;

export default function BrandHeader({ model: { name, logo } }: { model: ProductListBrandHeaderModel }) {
    const contentfulContext = useContext(ContentfulContext);
    if (contentfulContext) return null;

    return (
        <Layout.Section>
            {logo && (
                <ImageContainer>
                    <PictureWithLink props={logo} />
                </ImageContainer>
            )}

            <StyledHeadline forwardedAs="h1" size="L" logo={logo}>
                {name}
            </StyledHeadline>
        </Layout.Section>
    );
}
